import { useJourneyBuilder } from '@opap/jbca-postmonger-react';
import type { IInteractionTriggerEventDefinition } from '@opap/jbca-postmonger-react/lib/interfaces/interaction';
import to from 'await-to-js';
import { useEffect, useState } from 'react';
import { useSessionStorage } from './useSessionStorage';

export type InteractionTriggerEventDefinition = IInteractionTriggerEventDefinition & {
  dataExtensionId: string;
};

export function useInteractionTriggerEventDefinition() {
  const { getInteractionTriggerEventDefinition } = useJourneyBuilder();
  const [eventDefinitionModel, setEventDefinitionModel] = useState<InteractionTriggerEventDefinition>(
    {} as InteractionTriggerEventDefinition
  );
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { setValue: setDataExtensionId } = useSessionStorage('dataExtensionId', '');
  const { setValue: setEventDefinitionKey } = useSessionStorage('eventDefinitionKey', '');
  const { setValue: setHugeDEError } = useSessionStorage('hugeDEError', false);

  useEffect(() => {
    const fetchInteractionTriggerEventDefinition = async () => {
      const [err, eventDefinitionModelResp] = await to(
        getInteractionTriggerEventDefinition() as Promise<InteractionTriggerEventDefinition>
      );

      if ((err || !eventDefinitionModelResp) && !ignore) {
        const genericError = new Error('Error fetching InteractionTriggerEventDefinition');
        setError(genericError);
        setIsPending(false);
        console.error('Error fetching InteractionTriggerEventDefinition:', err);
      }

      if (eventDefinitionModelResp && !ignore) {
        setEventDefinitionModel(eventDefinitionModelResp);
        setIsPending(false);
        const { dataExtensionId, eventDefinitionKey } = eventDefinitionModelResp;
        const hugeDEError = (!eventDefinitionKey || eventDefinitionKey?.startsWith('ContactEvent')) ?? false;
        setDataExtensionId(dataExtensionId ?? '');
        setEventDefinitionKey(eventDefinitionKey ?? '');
        setHugeDEError(hugeDEError);
      }
    };

    let ignore = false;
    fetchInteractionTriggerEventDefinition();
    return () => {
      ignore = true;
    };
  }, [getInteractionTriggerEventDefinition, setDataExtensionId, setEventDefinitionKey, setHugeDEError]);

  return { eventDefinitionModel, isPending, error };
}
